import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  IconButton,
  type IconButtonProps,
  Popover,
  Typography,
  type TypographyProps,
} from "@mui/material";
import { omit } from "lodash-es";
import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { usePopover } from "../../../../../utils/hooks/use-popover";
import type { ToolbarProps } from "./props";

export const ToolbarDropDown: FC<
  ToolbarProps &
    IconButtonProps & {
      icon?: React.JSX.Element;
      heading: string;
      open: boolean;
      setOpen: (open: boolean) => void;
      children: ReactNode;
      headingTypographyProps?: TypographyProps;
      "data-analytics-id": string;
    }
> = ({
  icon,
  heading,
  disabled,
  open,
  setOpen,
  children,
  "data-analytics-id": dataAnalyticsId,
  ...props
}) => {
  const { t } = useTranslation();
  const popover = usePopover<HTMLButtonElement | null>();

  return (
    <>
      <IconButton
        data-analytics-id={dataAnalyticsId}
        disabled={disabled}
        data-testid={`toolbar-${heading.toLocaleLowerCase()}`}
        ref={popover.anchorRef}
        onClick={() => setOpen(!open)}
        {...props}
      >
        <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
          {icon}
          {heading && (
            <Typography
              sx={{
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "80px",
                ...(props.headingTypographyProps?.sx ?? {}),
              }}
              {...(omit(props.headingTypographyProps, "sx") ?? {})}
            >
              {t(heading)}
            </Typography>
          )}
          <KeyboardArrowDown />
        </Box>
      </IconButton>
      <Popover
        // eslint-disable-next-line react-hooks/refs
        anchorEl={popover.anchorRef.current}
        onClose={() => setOpen(false)}
        open={open}
        sx={{ minWidth: 100, padding: 5, maxWidth: 300 }}
      >
        <Box display="flex" flexDirection="column">
          {children}
        </Box>
      </Popover>
    </>
  );
};
